import React from 'react'
import { Navigate, Outlet, useLocation } from "react-router-dom";

const PublicLayout = () => {
  return (
    <>
      <div>
        <Outlet />
      </div>
    </>
  )
}

export default PublicLayout
